if (!customElements.get('jm-flip-categories')) {
  customElements.define('jm-flip-categories', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.cards = Array.from(this.querySelectorAll('.jm-flip-card'));
      this.cards.forEach(card => {
        const visual = card.querySelector('.jm-flip-visual');
        card.addEventListener('pointerenter', event => {
          if (event.pointerType === 'mouse' || event.pointerType === 'pen') this.setFlipped(card, true);
        }, options);
        card.addEventListener('pointerleave', event => {
          if (event.pointerType !== 'touch') this.setFlipped(card, false);
        }, options);
        card.addEventListener('pointercancel', () => this.setFlipped(card, false), options);
        visual.addEventListener('click', () => {
          // Buttons flip on touch/Enter/Space; links keep their original navigation.
          if (visual.tagName === 'BUTTON') this.setFlipped(card, !card.classList.contains('is-flipped'));
        }, options);
        card.addEventListener('focusout', event => {
          if (!card.contains(event.relatedTarget)) this.setFlipped(card, false);
        }, options);
        card.addEventListener('keydown', event => {
          if (event.key === 'Escape') this.setFlipped(card, false);
        }, options);
      });
      this.addEventListener('shopify:block:select', event => {
        this.cards.forEach(card => this.setFlipped(card, card.dataset.blockId === event.detail.blockId));
      }, options);
      this.addEventListener('shopify:block:deselect', () => this.reset(), options);
      window.addEventListener('blur', () => this.reset(), options);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.reset();
      }, options);
    }
    setFlipped(card, flipped) {
      card.classList.toggle('is-flipped', flipped);
      const button = card.querySelector('button.jm-flip-visual');
      if (button) button.setAttribute('aria-pressed', String(flipped));
    }
    reset() {
      this.cards?.forEach(card => this.setFlipped(card, false));
    }
    disconnectedCallback() {
      this.reset();
      this.controller?.abort();
      this.controller = null;
    }
  });
}
